<template>
    <div id="pageTable">
        <v-container grid-list-xl>
            <v-layout row wrap>
                <v-flex lg12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="emitEvent('create')" small>{{$t('new')}}</v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-treeview :items="listTreeCategories">
                                <template slot="label" slot-scope="{ item, open, leaf }">
                                    {{item.name}}
                                    <v-btn color="primary" flat icon small @click="emitEvent('withparent', item._id)">
                                        <v-icon class="icon material-icons">add</v-icon>
                                    </v-btn>
                                    <v-btn color="success" flat icon small @click="emitEvent('update',item._id)">
                                        <v-icon class="icon material-icons">create</v-icon>
                                    </v-btn>
                                    <v-btn color="error" flat icon small @click="emitEvent('remove', item)">
                                        <v-icon class="icon material-icons">delete</v-icon>
                                    </v-btn>
                                </template>
                            </v-treeview>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'list',
  data () {
    return {
      tree: [],
      canCheck: true,
      control: true,
      search: ''
    }
  },
  mounted () {
  },
  computed: {
    ...mapGetters({
      listTreeCategories: 'categories/categoriesTree'
    })
  },
  methods: {
    emitEvent (evento, id = 0) {
      if (id) {
        this.$emit(evento, id)
      } else {
        this.$emit(evento)
      }
    }
  }
}
</script>
<style>
    .v-treeview-node__label {
        font-size: 1.0rem;
        margin-left: 6px;
        flex-grow: 1;
        flex-shrink: 0;
    }
</style>
